module.exports = __webpack_public_path__ + "static/media/Intro.cb6aa6dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/Intro.png
// module id = 484
// module chunks = 0